import { CreditCard, BarChart3, Gift, FileText } from "lucide-react";
import { cn } from "@/lib/utils";

interface TaskTypeBadgeProps {
  type: "standard" | "cash" | "offset" | "bonus";
  className?: string;
  withLabel?: boolean;
  size?: "sm" | "md" | "lg";
}

export function TaskTypeBadge({ type, className, withLabel = false, size = "md" }: TaskTypeBadgeProps) {
  const iconSize = size === "sm" ? 12 : size === "md" ? 16 : 20;
  const padding = size === "sm" ? "p-1" : size === "md" ? "p-1.5" : "p-2";
  
  // Základné štýly pre všetky typy
  const baseStyle = "rounded-full flex items-center justify-center";
  
  // Špecifické štýly podľa typu úlohy
  const styles = {
    standard: "bg-blue-100 text-blue-700 hover:bg-blue-200",
    cash: "bg-green-100 text-green-700 hover:bg-green-200",
    offset: "bg-orange-100 text-orange-700 hover:bg-orange-200",
    bonus: "bg-purple-100 text-purple-700 hover:bg-purple-200"
  };
  
  // Názvy typov pre zobrazenie
  const labels = {
    standard: "Štandardná",
    cash: "Hotovosť",
    offset: "Zápočet",
    bonus: "Bonus"
  };
  
  // Ikony pre jednotlivé typy úloh
  const icons = {
    standard: <FileText size={iconSize} />,
    cash: <CreditCard size={iconSize} />,
    offset: <BarChart3 size={iconSize} />,
    bonus: <Gift size={iconSize} />
  };
  
  return (
    <div 
      className={cn(
        baseStyle, 
        styles[type], 
        padding,
        withLabel ? "gap-1.5" : "",
        className
      )}
      title={labels[type]}
    >
      {icons[type]}
      {withLabel && <span className={`${size === "sm" ? "text-xs" : "text-sm"} font-medium`}>{labels[type]}</span>}
    </div>
  );
}